module.exports = __webpack_public_path__ + "static/demo-e37c2fae58ef1b163ac7bceae4cd7587.jpg";